<template>
  <v-toolbar class="toolbar" elevation="0" dense>
    <v-toolbar-title>
      <h4>Guias de faturamento</h4>
    </v-toolbar-title>
    <v-spacer />
    <div class="mr-2">
      <conciliacao-faturamento-guias-sort />
    </div>
    <conciliacao-faturamento-guias-filter />
  </v-toolbar>
</template>

<script>
import ConciliacaoFaturamentoGuiasFilter from './ConciliacaoFaturamentoGuiasFilter.vue'
import ConciliacaoFaturamentoGuiasSort from './ConciliacaoFaturamentoGuiasSort.vue'

export default {
  components: {
    ConciliacaoFaturamentoGuiasFilter,
    ConciliacaoFaturamentoGuiasSort
  }
}
</script>
